import type { ReactElement } from 'react';
import React, { cloneElement, forwardRef, Fragment } from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';
import PropTypes from 'prop-types';

import Box from '../../layouts/Box';
import type {
  ButtonsProps,
  OverlayContentProps,
  StyledOverlayContentProps,
} from './types';

const StyledOverlayContent = styled(Box, {
  shouldForwardProp,
})<StyledOverlayContentProps>(({ scroll }) =>
  css({
    fontSize: 'body.2',
    lineHeight: 'body',
    overflowY: scroll ? 'scroll' : 'auto',
    height: '100%',
    WebkitOverflowScrolling: scroll ? 'touch' : 'auto', // smooth scroll on ios
  })
);

const OverlayContent = forwardRef<HTMLDivElement, OverlayContentProps>(
  ({ children, buttons, onClose, scroll, ...rest }, ref) => (
    <Fragment>
      <StyledOverlayContent ref={ref} scroll={scroll} {...rest}>
        {children}
      </StyledOverlayContent>
      {buttons && cloneElement(buttons, { onClose })}
    </Fragment>
  )
);

OverlayContent.propTypes = {
  buttons: PropTypes.shape({
    onClose: PropTypes.func,
    direction: PropTypes.string,
  }) as PropTypes.Validator<
    ReactElement<Partial<ButtonsProps>> | null | undefined
  >,
  onClose: PropTypes.func,
  scroll: PropTypes.bool,
};

export default OverlayContent;
